export default __webpack_public_path__ + "static/media/premiumplus.2828a108.png";